import React from "react";
import { connect } from "react-redux";

import Category from "./Category/Category";
import classes from "./Categories.module.css";

const categories = (props) => (
  <div className={classes.Container}>
    <div className={classes.Categories}>
      {props.categories.map((category) => {
        let active = false;
        if (category.name === props.currentCategory) {
          active = true;
        }
        return (
          <Category
            name={category.name}
            image={category.image}
            key={category.name}
            active={active}
            clicked={() => props.selectCategory(category.name)}
          />
        );
      })}
      {props.paidCategories.map((category, index) => {
        let isPurchased = false;
        let active = false;
        props.purchased.map((purchasedCategory) => {
          if (purchasedCategory === category.name) {
            isPurchased = true;
            if (category.name === props.currentCategory) {
              active = true;
            }
          }
          return null;
        });
        if (isPurchased) {
          return (
            <Category
              name={category.name}
              key={category.name}
              active={active}
              image={require(`../../illustrations/${category.image}`).default}
              clicked={() => props.selectCategory(category.name)}
            />
          );
        } else {
          return (
            <Category
              name={category.name}
              key={category.name}
              image={require(`../../illustrations/${category.image}`).default}
              clicked={() => props.selectPaidCategory(index)}
              notPurchased
            />
          );
        }
      })}
    </div>
  </div>
);

const mapStateToProps = (state) => ({
  purchased: state.purchased,
});

export default connect(mapStateToProps)(categories);
